"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("./utils");

var _styles = require("@material-ui/styles");

var _clsx = _interopRequireDefault(require("clsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Svg = (0, _styles.styled)("svg")({
  display: "block"
});

var DiscreteColorScale = function DiscreteColorScale(_ref) {
  var chunks = _ref.chunks,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 200 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 24 : _ref$height,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  } : _ref$margin,
      _ref$rectProps = _ref.rectProps,
      rectProps = _ref$rectProps === void 0 ? {} : _ref$rectProps,
      className = _ref.className;
  var innerWidth = width - (margin.left + margin.right);
  var positionRange = [0, innerWidth];
  var percentToPosition = (0, _utils.getPositionScale)("linear", [0, 1], positionRange);
  return /*#__PURE__*/_react["default"].createElement(Svg, {
    className: (0, _clsx["default"])("HypScale-colors", "HypScale-discrete", className),
    width: width,
    height: height
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(".concat(margin.left, " ").concat(margin.top, ")")
  }, chunks.map(function (c, i) {
    return /*#__PURE__*/_react["default"].createElement("rect", _extends({
      key: c.value,
      x: percentToPosition(c.x),
      y: 0,
      height: height - (margin.bottom + margin.top),
      width: c.width * innerWidth,
      style: {
        fill: c.color
      }
    }, rectProps));
  })));
};

DiscreteColorScale.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DiscreteColorScale",
  "props": {
    "width": {
      "defaultValue": {
        "value": "200",
        "computed": false
      },
      "required": false
    },
    "height": {
      "defaultValue": {
        "value": "24",
        "computed": false
      },
      "required": false
    },
    "margin": {
      "defaultValue": {
        "value": "{ left: 0, right: 0, top: 0, bottom: 0 }",
        "computed": false
      },
      "required": false
    },
    "rectProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "required": false
    }
  }
};
var _default = DiscreteColorScale;
exports["default"] = _default;